import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { GET_ENROLLMENT_CONTEXT_QUERY_KEY } from 'theSource/queries';
import { ContextCardContainerStyled } from '../../EnrollmentBoxStyled';
import { Card } from 'components';
import { queryClient, useApiMutation } from 'theSource/utils';
import { ErrorResponseDto, ResponseDto } from 'theSource/types';
import { PsButtonTuner } from 'stencilSetup';
import { ROUTES } from 'enrollment/app/routes';
import { ROUTES as SOURCE_ROUTES } from 'theSource/app/routes';
import { setEnrollmentOrgPlanYearId } from 'theSource/features/Home/components/EnrollmentBanner/services';
import { GET_AVAIL_PLAN_YEARS_QUERY_KEY } from 'theSource/queries/useAvailablePlanYearsQuery/utils';

interface AddPlanYearCardProps {
  orgPlanYearId: number;
  subscriberLifeEventId: number;
  lifeEventCompleted?: boolean;
}

export const ADD_PLAN_YEAR_QUERY_KEY = 'addPlanYear';

export const AddPlanYearCard = ({
  orgPlanYearId,
  subscriberLifeEventId,
  lifeEventCompleted = false,
}: AddPlanYearCardProps) => {
  const { t } = useTranslation('pages.home');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { mutate: addPlanYear } = useApiMutation<
    ResponseDto,
    ErrorResponseDto,
    {}
  >({
    queryKey: ADD_PLAN_YEAR_QUERY_KEY,
    queryKeysToInvalidate: GET_ENROLLMENT_CONTEXT_QUERY_KEY,
    method: 'post',
    endpoint: `/life_events/${subscriberLifeEventId}/add_plan_year?org_plan_year_id=${orgPlanYearId}&life_event_completed=${lifeEventCompleted}`,
    onSuccess: () => {
      queryClient.invalidateQueries(GET_AVAIL_PLAN_YEARS_QUERY_KEY);
    },
    getErrorMessage: (error) => error.response?.data?.details,
    showSuccessSnackbar: false,
  });

  const handleClick = () => {
    addPlanYear({});
    dispatch(setEnrollmentOrgPlanYearId(orgPlanYearId));
    navigate(
      `${SOURCE_ROUTES.enrollment.path}/${ROUTES.enrollment.beforeStarted.path}`
    );
  };

  return (
    <Card
      showBorder
      additionalClasses="context"
      dataTestId="add-plan-year-card"
    >
      <div className="row">
        <h2>{t('planForNextHeader')}</h2>
      </div>
      <div className="row pt-2">
        <div className="body1">{t('planForNextBody')}</div>
      </div>
      <div className="row pt-3">
        <PsButtonTuner
          buttonId="add_plan_year"
          label={t('addPlanYear')}
          level="secondary"
          onClick={handleClick}
        />
      </div>
    </Card>
  );
};
